import React, { useState } from 'react';
import { Alert, Form, Spinner } from 'reactstrap';
import Btn from '../../shims/commonUiBtn';
import FileAttachmentZone, { MAX_FILES } from './FileAttachmentZone';
import { attachFiles } from '../../api/ticketApi';

export default function AttachFilesForm({ ticketId, existingCount = 0, onUploaded }) {
  const maxFiles = Math.max(0, MAX_FILES - (existingCount || 0));
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [warnings, setWarnings] = useState([]);

  const handleFilesChange = (newFiles, err) => {
    setFiles(newFiles);
    setFileError(err);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
    setWarnings([]);
    if (fileError) return;
    if (files.length === 0) {
      setErrorMessage('Select at least one file to upload.');
      return;
    }
    setIsLoading(true);
    setUploadProgress(0);
    try {
      const res = await attachFiles(ticketId, files, { onProgress: setUploadProgress });
      setUploadProgress(100);
      if (res?.attachmentWarnings?.length) setWarnings(res.attachmentWarnings);
      setFiles([]);
      onUploaded?.(res);
    } catch (err) {
      const msg =
        err?.json?.message || err?.json?.error || 'Failed to upload attachments. Please try again.';
      setErrorMessage(msg);
    } finally {
      setIsLoading(false);
      setUploadProgress(null);
    }
  };

  if (maxFiles <= 0) {
    return (
      <p className="text-muted mt-2 mb-0">
        Maximum of {MAX_FILES} attachments per ticket reached.
      </p>
    );
  }

  return (
    <Form className="theme-form mt-2" onSubmit={handleSubmit}>
      {errorMessage && (
        <Alert color="danger" toggle={() => setErrorMessage(null)} className="mb-2">
          {errorMessage}
        </Alert>
      )}
      {warnings.length > 0 && (
        <Alert color="warning" toggle={() => setWarnings([])} className="mb-2">
          Some files could not be attached: {warnings.join(' ')}
        </Alert>
      )}
      <FileAttachmentZone
        files={files}
        onChange={handleFilesChange}
        error={fileError}
        disabled={isLoading}
        uploadProgress={uploadProgress}
        maxFiles={maxFiles}
        label={`Add attachments (up to ${maxFiles} more, 10 MB each)`}
      />
      <div className="d-flex align-items-center gap-2 mt-2">
        <Btn attrBtn={{ type: 'submit', color: 'primary', disabled: isLoading || files.length === 0 }}>
          {isLoading ? <Spinner size="sm" color="light" /> : 'Upload files'}
        </Btn>
      </div>
    </Form>
  );
}
